<template>
  <!-- width="600px" 或者  width="60%"   -->
  <el-dialog :close-on-click-modal="false" title="编辑收款" :show-close="true" :visible="true"
    :before-close="handleBeforeClose" width="725px">
    <div class="dialog__container">
      <el-form inline ref="form" class="search-form" label-position="right" :model="form" :rules="rules"
        label-width="100px">
        <el-form-item label="应收单据号:" prop="receiveNo" class="input-with-col2 mr0">
          <el-input size="mini" disabled v-model.trim="form.receiveNo" placeholder="系统自动生成" clearable></el-input>
        </el-form-item>
        <el-form-item label="单据日期:" prop="billDate" class="input-with-col2 mr0">
          <el-date-picker v-model="form.billDate" size="mini" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
            unlink-panels clearable></el-date-picker>
        </el-form-item>
        <el-form-item label="应收类型:" prop="spending" class="input-with-col2 mr0">
          <el-select size="mini" v-model="form.spending" filterable placeholder="请选择支出项" clearable value-key="code">
            <el-option v-for="item in spendingList" :key="item.code" :label="item.name" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户:" prop="propertyUnit" class="input-with-col2 mr0">
          <el-select size="mini" v-model="form.propertyUnit" filterable placeholder="请选择客户" clearable value-key="id">
            <el-option v-for="item in propertyUnitSimpleList" :key="item.id" :label="item.unitName"
              :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="总金额:" prop="inMoney" class="input-with-col2 mr0">
          <el-input size="mini" type="number" v-model.trim="form.inMoney" placeholder="请输入总金额" clearable></el-input>
        </el-form-item>

        <el-form-item label="维保员:" prop="user" class="input-with-col2 mr0">
          <el-select size="mini" v-model="form.user" filterable placeholder="请选择维保员" clearable value-key="userId">
            <el-option v-for="item in userList" :key="item.userId" :label="item.nickname" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="电梯信息:" prop="liftInfo" class="input-with-col2 mr0">
          <el-input size="mini" v-model.trim="form.liftInfo" placeholder="请输入liftInfo" clearable></el-input>
        </el-form-item>
        <el-form-item label="配件费:" prop="proMoney" class="input-with-col2 mr0">
          <el-input size="mini" type="number" v-model.trim="form.proMoney" placeholder="请输入配件费" clearable></el-input>
        </el-form-item>
        <el-form-item label="人工费:" prop="personMoney" class="input-with-col2 mr0">
          <el-input size="mini" type="number" v-model.trim="form.personMoney" placeholder="请输入人工费" clearable></el-input>
        </el-form-item>
        <el-form-item label="备注:" prop="remark" class="input-with-col2 mr0">
          <el-input size="mini" v-model.trim="form.remark" placeholder="请输入备注" clearable></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="plr28" size="mini" type="info" plain @click="handleCancel">取消</el-button>
      <el-button class="plr28" type="primary" size="mini" :loading="loadBtn" @click="handleConfirm">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import {
    saveReceive,
    userSimpleList,
    getReceiveTypeList,
    getPropertyUnitSimpleList
  } from '@/api/Receive'
  import {
    getCardList
  } from '@/api/Card'

  import cookies from '../../../libs/util.cookies'
  export default {
    data() {
      return {
        spendingList: [],
        userList: [],
        cardList: [],
        propertyUnitSimpleList: [],
        form: {
          spending: {},
          propertyUnit: {},
          user: {},
          billDate: '',
          inMoney: '',
          proMoney: '',
          personMoney: '',
          liftInfo: '',
          remark: ''
        },
        rules: {
          billDate: [{
            required: true,
            message: "请选择支出项",
            trigger: "blur",
          }, ],
          spending: [{
            required: true,
            message: "请选择支出项",
            trigger: "blur",
          }, ],
          inMoney: [{
            required: true,
            message: "请输入金额",
            trigger: "blur",
          }, ],
          user: [{
            required: true,
            message: '请选择付款人信息',
            trigger: 'blur'
          }],
          propertyUnit: [{
            required: true,
            message: '请选择客户',
            trigger: 'blur'
          }]
        },
        loadBtn: false,
      };
    },
    props: {
      detail: {
        required: true,
        type: Object
      }
    },
    created() {
      this.form = {
        ...this.detail
      }
      this.form.spending = {
        code: this.form.type,
        name: this.form.typeName
      };

      this.form.propertyUnit = {
        id: this.form.propertyUnitId,
        unitName: this.form.propertyUnitName,
      };
      this.form.user = {
        userId: this.form.payUserId,
        nickname: this.form.payUserName,
      };
      this.handleSpendingList();
      this.handleUserSimpleList();
      this.handlePropertyUnitSimpleList();
    },
    methods: {
      async handleCardList() {
        const res = await getCardList({});
        if (res.code === 200) {
          this.cardList = res.data
        }
      },
      async handlePropertyUnitSimpleList() {
        const res = await getPropertyUnitSimpleList({});
        if (res.code === 200) {
          this.propertyUnitSimpleList = res.data
        }
      },
      async handleUserSimpleList() {
        const res = await userSimpleList({});
        if (res.code === 200) {
          this.userList = res.data
        }
      },
      async handleSpendingList() {
        const res = await getReceiveTypeList();
        if (res.code === 200) {
          this.spendingList = res.data
        }
      },
      inArray(needle, array) {
        for (var i = 0; i < array.length; i++) {
          if (needle === array[i]) {
            return true;
          }
        }
        return false;
      },
      handleBeforeClose(done) {
        this.$emit("cancel");
        done();
      },
      handleCancel() {
        this.$emit("cancel");
      },
      async handleConfirm() {
        console.log(this.form)
        if (this.loadBtn) return;
        this.$refs["form"].validate(async (valid) => {
          if (valid) {
            this.loadBtn = true;
            const params = {
              ...this.form
            }
            console.log(params)
            params.type = params.spending.code;
            params.typeName = params.spending.name;
            params.propertyUnitId = params.propertyUnit.id;
            params.propertyUnitName = params.propertyUnit.unitName;
            params.repairUserId = params.user.userId;
            params.repairUserName = params.user.nickname;
            if (params.type != 30) {
              delete params.repairUserId;
              delete params.repairUserName;
              delete params.proMoney;
              delete params.personMoney;
              delete params.liftInfo;
            }
            delete params.propertyUnit;
            delete params.user;
            delete params.spending;
            console.log(params)
            const res = await saveReceive(params);
            if (res.code === 200) {
              this.$message.success("添加成功");
              this.$emit("confirm");
            }
            this.loadBtn = false;
          }
        });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/pages/ReceiveManagement/components/EditCause.vue